/**
 * @generated SignedSource<<4ede03d325dfe0818e3c11d176a7b70b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RouteConfig_Register_Query$variables = {
  customLandingHostname: string;
};
export type RouteConfig_Register_Query$data = {
  readonly viewer: {
    readonly customPortal: {
      readonly " $fragmentSpreads": FragmentRefs<"PortalRegistrationPage_customPortal">;
    } | null;
  };
};
export type RouteConfig_Register_Query = {
  response: RouteConfig_Register_Query$data;
  variables: RouteConfig_Register_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customLandingHostname"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "customLandingHostname",
    "variableName": "customLandingHostname"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RouteConfig_Register_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CustomPortalNode",
            "kind": "LinkedField",
            "name": "customPortal",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PortalRegistrationPage_customPortal"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RouteConfig_Register_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CustomPortalNode",
            "kind": "LinkedField",
            "name": "customPortal",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomPortalAgreementNodeConnection",
                "kind": "LinkedField",
                "name": "agreements",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomPortalAgreementNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomPortalAgreementNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contactEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerFontColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "faviconUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "footerImageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoImageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "privacyPolicyUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "termsLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "termsUrl",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1d280357d3eb3393928a4801128c1e0b",
    "id": null,
    "metadata": {},
    "name": "RouteConfig_Register_Query",
    "operationKind": "query",
    "text": "query RouteConfig_Register_Query(\n  $customLandingHostname: String!\n) {\n  viewer {\n    customPortal(customLandingHostname: $customLandingHostname) {\n      ...PortalRegistrationPage_customPortal\n      id\n    }\n  }\n}\n\nfragment PortalRegistrationPage_customPortal on CustomPortalNode {\n  agreements {\n    edges {\n      node {\n        id\n        text\n      }\n    }\n  }\n  contactEmail\n  customColor\n  headerFontColor\n  faviconUrl\n  footerImageUrl\n  logoImageUrl\n  pageTitle\n  privacyPolicyUrl\n  termsLabel\n  termsUrl\n}\n"
  }
};
})();

(node as any).hash = "899e25026371f26a2154125b86554957";

export default node;
